var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMbx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMbx0)",
    d: "M5.143 17.571V7.286H7.88l4.054 3.951l4.059-3.951h2.863V17.57H18.6l-1.787-1.757l-3.078-2.85l.099-.085l2.88 2.665V9.227l-4.779 4.35l-4.65-4.35v6.317l2.88-2.665l.099.085l-4.971 4.607H5.18l-.017-.017zm6.372-3.484l.099.086l-3.669 3.398h-.188zm-.342-.309l.098.086l-3.998 3.707H7.08zm-.326-.29l.098.085L6.63 17.57h-.193l4.414-4.084zm-.317-.284l.098.086l-4.62 4.281h-.193zm1.954.883l-.099.086l3.669 3.398h.189zm.343-.309l-.099.086l3.999 3.707h.193zm.326-.29l-.099.085l4.316 3.998h.193l-4.415-4.084zm.317-.284l-.099.086l4.62 4.281h.193z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMbx0",
    x1: 5.143,
    x2: 12.925,
    y1: 8.057,
    y2: 15.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9600FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbx);
export default __webpack_public_path__ + "static/media/mbx.83695e7262ee248f98e67e863a809a2a.svg";
export { ForwardRef as ReactComponent };